// extracted by mini-css-extract-plugin
export default {"item":"styles_item__EjCJm","is-dragging":"styles_is-dragging__+V4DP"};